/**
 * @generated SignedSource<<645e503db73a87aa192b8645c790e241>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type LogoutButtonMutation$variables = Record<PropertyKey, never>;
export type LogoutButtonMutation$data = {
  readonly logoutUser: boolean;
};
export type LogoutButtonMutation = {
  response: LogoutButtonMutation$data;
  variables: LogoutButtonMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "logoutUser",
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutButtonMutation",
    "selections": (v0/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "LogoutButtonMutation",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "89a8158fefc7b77f811c74598bce06f1",
    "id": null,
    "metadata": {},
    "name": "LogoutButtonMutation",
    "operationKind": "mutation",
    "text": "mutation LogoutButtonMutation {\n  logoutUser\n}\n"
  }
};
})();

(node as any).hash = "b945299cf1156dca590f8f2073cbe126";

export default node;
